<template>
  <table class="jinnang-table">
    <thead class="table-row table-head">
      <th
        class="table-head-cell"
        v-for="(item, index) of titleList"
        :key="index"
        :class="[
          item.class,
          activeSortIndex === index &&
          item.sort.direction === SortDirection.descending
            ? 'descending'
            : '',
          activeSortIndex === index &&
          item.sort.direction === SortDirection.ascending
            ? 'ascending'
            : ''
        ]"
      >
        <span
          :class="['title-name', item.sort ? 'pointer' : '']"
          @click="sortClick(item, index)"
        >
          {{ item.text }}
          <span v-if="item.sort" class="caret-wrapper">
            <span class="sort-caret ascending"></span>
            <span class="sort-caret descending"></span>
          </span>
        </span>
      </th>
    </thead>
    <tr
      v-for="(item, index) of dataList"
      @click="rowClick(item)"
      :key="index"
      class="table-row"
    >
      <td
        v-for="(subItem, subIndex) of item.tds"
        :key="subIndex"
        :class="subItem.class"
      >
        {{ subItem.text }}
      </td>
      <slot name="operation" v-bind:item="item.tr"></slot>
    </tr>
  </table>
</template>

<script>
const SortDirection = {
  /**
   * 没有应用排序
   */
  none: 0,
  /**
   * 升序
   */
  ascending: 1,
  /**
   * 降序
   */
  descending: -1
}
export default {
  name: 'BaseJinNangTable',
  components: {},
  props: {
    titleList: {
      type: Array,
      required: true
    },
    dataList: {
      type: Array,
      required: false
    },
    sortTitle: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      SortDirection,
      activeSortIndex: -1,
      width100: 'width100px'
    }
  },
  created() {},
  computed: {},
  methods: {
    rowClick(item) {
      this.$emit('row-clicked', item)
    },
    sortClick(item, index) {
      if (item.sort) {
        this.activeSortIndex = index
        item.sort.direction =
          item.sort.direction === SortDirection.none ||
          item.sort.direction === SortDirection.descending
            ? SortDirection.ascending
            : SortDirection.descending
        this.$emit('titleSort', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-row {
  height: 45px;
  background-color: #ffffff;
}

.table-head {
  background-color: #f0f0f0;
  border-radius: 5px 5px 0px 0px;
}

.table-head > th {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  height: 40px;
  line-height: 40px;
  letter-spacing: 1px;
  color: #858585;
  flex: auto;
  text-align: center;
  border-right: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}

th:first-child {
  border-radius: 5px 0px 0px 0px;
}

th:last-child {
  border-radius: 0px 5px 0px 0px;
}

.table-row > td {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  text-align: center;
  border-right: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}

.jinnang-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border-bottom: none;
  border-left: 1px solid #ebebeb;
  border-radius: 5px 5px 0px 0px;
}

.width100px {
  width: 100px;
}

.pointer {
  cursor: pointer;
}

.title-name {
  display: inline-flex;
  align-items: center;
}

.caret-wrapper {
  display: inline-flex;
  height: 34px;
  width: 10px;
  overflow: initial;
  position: relative;
  .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 2px;

    &.ascending {
      border-bottom-color: #c0c4cc;
      top: 5px;
    }

    &.descending {
      border-top-color: #c0c4cc;
      bottom: 7px;
    }

    .ascending &.ascending {
      border-bottom-color: #409eff;
    }

    .descending &.descending {
      border-top-color: #409eff;
    }
  }
}
</style>
